import React from 'react'
import './Events.scss'
import EventsListing from 'components/events/EventsListing'

function EventsPage() {
  return <EventsListing />
}

export default EventsPage
